<app-page>
    <app-title>{{ 'disputed_orders' | translate }}</app-title>
    <app-orders [ordersModel]="disputedOrdersModel"></app-orders>
</app-page>
